<template>
  <div
    :class="{'nav-top': true, 'static-header': staticNavbar}"
    :style="stylesheet"
  >
    <v-container class="text-xs-left nav-top" :style="stylesheet">
      <v-layout row wrap>
        <v-flex v-if="shortHeader" md5 lg5 xl6 class="hidden-sm-and-down mt-1">
          <router-link :to="{name: 'Index'}">
            <v-icon color="white">backspace</v-icon> {{ $t('general.back') }}
          </router-link>
        </v-flex>
        <v-flex v-if="!shortHeader" xs1 sm1 md5 lg5 xl6 class="hidden-xs-only mt-1">
          <router-link :to="{name: 'HelpAndSupport'}" style="float:left">
            <v-icon color="#F5F5E9!important" size="18">record_voice_over</v-icon>
            <span class="hidden-sm-and-down">{{ $t('general.helpAndSupport') }}</span>
          </router-link>
        </v-flex>
        <v-flex xs11 sm11 md7 lg7 xl6 class="text-xs-right mt-1 pr-1">
          <div v-if="storeAuth.authorized === false">
            <router-link class="hidden-sm-and-up" :to="{name: 'Register'}">
              {{ $t('general.register') }}
            </router-link>
            <router-link class="hidden-xs-only" :to="{name: 'Register'}">
              {{ $t('topBar.registerHere') }}
            </router-link>
            <router-link :to="{name: 'Login'}">
              <v-btn small outline color="white" style="margin:0px;margin-top:-3px">
              {{ $t('general.login') }}
            </v-btn>
            </router-link>
            <LanguageSelector v-if="$VENDOR === 'resol'"></LanguageSelector>
          </div>
          <div v-else>
            <v-btn
              v-if="storeUser && storeUser.isForeign && storeAdminElements"
              v-clipboard="storeUser.email"
              outline
              small
              color="purple darken-2"
              style="margin:0px;margin-top:-3px"
              class="mr-2"
            >
              <v-icon left>fa-clipboard</v-icon>email
            </v-btn>

            <router-link
              style="font-weight:400;"
              class="mr-1"
              id="ruler"
              :to="{name: 'My-Profile'}">
            </router-link>
            <v-btn small outline class="hidden-xs-only" color="white" style="margin:0px;margin-top:-3px" @click="logout(false)">
              {{ $t('general.logout') }}
            </v-btn>
            <v-icon
              outline class="hidden-sm-and-up"
              color="white"
              style="margin:0px;margin-top:0px;font-size:20px"
              @click="logout(false)"
            >
              fa-sign-out
            </v-icon>

            <router-link slot="activator" class="pl-2" :to="{name: 'AdminDashboard'}">
              <v-icon
                v-if="storeUser && storeUser.role >= 100"
                size="20"
                style="color:#f5f5f2;"
              >fa-shield</v-icon>
            </router-link>

            <v-tooltip bottom>
              <router-link slot="activator" class="pl-2" :to="{path: '/settings'}">
                <v-icon
                  size="20"
                  style="color:#f5f5f2;"
                >fa-cog</v-icon>
              </router-link>
              <span>{{ $t('general.preferences') }}</span>
            </v-tooltip>

            <LanguageSelector v-if="$VENDOR === 'resol'"></LanguageSelector>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const LanguageSelector = () => import('@/client/components/LanguageSelector')

export default {
  props: {
    shortHeader: {
      type: Boolean
    },
    staticNavbar: {
      type: Boolean
    }
  },
  components: {
    LanguageSelector
  },
  computed: {
    ...mapGetters([
      'storeAuth',
      'storeUser',
      'storeAdminElements'
    ])
  },
  watch: {
    storeUser: function (val, oldVal) {
      if (val) {
        this.$nextTick(() => {
          this.setAccountName(val)
          this.setStylesheet(val)
        })
      } else {
        this.stylesheet = 'background-color:#696969'
      }
    }
  },
  data () {
    return {
      accountName: '',
      stylesheet: 'background-color:#696969'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setAccountName(this.storeUser)
      this.setStylesheet(this.storeUser)
      window.addEventListener('resize', this.setAccountName)
    })
  },
  destroyed () {
    window.removeEventListener('resize', this.setAccountName)
  },
  methods: {
    setStylesheet (user) {
      if (user) {
        if (this.$VENDOR === 'resol') {
          this.stylesheet = (user.isAdmin) ? 'background-color:#8e4646' : (user.isDistribution) ? 'background-color:#3fa535' : (user.isSupport) ? 'background-color:#46558e' : ''
        }
      } else {
        this.stylesheet = 'background-color:#696969'
      }
    },
    getRulerLength (accountName) {
      let ruler = document.getElementById('ruler')
      let offsetWidth = 0
      if (ruler) {
        ruler.innerHTML = accountName
        offsetWidth = ruler.offsetWidth
      }
      return offsetWidth
    },
    setAccountName (val) {
      let user = this.storeUser || val
      if (user) {
        const width = window.innerWidth
        let textWidth = this.getRulerLength(user.email)
        if (width - textWidth - 120 < 0) {
          let temp = user.email.split('@')
          textWidth = this.getRulerLength(temp[0])
          if (width - textWidth - 120 < 0) {
            if (user.username.length < temp[0].length) {
              this.getRulerLength(user.username)
            } else {
              this.getRulerLength('')
            }
          }
        }
      }
    },
    logout (closeDrawer) {
      this.getRulerLength('')
      this.$store.commit('setAuthorization', false)
      this.$store.commit('setUser', null)
      localStorage.removeItem('VBus.net-JWT')
      if (closeDrawer) {
        this.toggleDrawer()
      }
    }
  }
}
</script>

<style scoped>
a, a:visited, a:active {
  color: rgba(0,0,0,.54)!important;
  text-decoration: none;
} a:hover {
  color: rgba(0,0,0,.9)!important;
  text-decoration: none;
}
.nav-top {
  background-color: #696969;
  min-height: 38px;
}
.nav-top .container a, a:visited, a:hover, a:active {
  color: #f5f5f2!important;
  letter-spacing: 0.3px;
  line-height: 180%;
  font-size: 14px;
}.nav-top .container  {
  padding: 10px;
  padding-top: 3px;
  padding-bottom: 0px;
}
.static-header {
  position: fixed;
  top: 0px;
  z-index: 999;
  width: 100%;
}
#ruler {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/client/components/Navigation/Top.vue